<script lang="ts" setup></script>

<template>
  <footer>
    <div class="container">
      <p>有限会社 スマイルファミリー</p>
      <p>〒885-0001&emsp;宮崎県都城市金田町1835-1</p>
      <p>0120-14-5220</p>
      <p>smile-f97@celery.ocn.ne.jp</p>

      <div class="policy_links">
        <a
          href="/pdf/privacy_policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          個人情報の取り扱いについて
        </a>
        <span class="separator">|</span>
        <a
          href="/pdf/customer_oriented_policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          お客様本位の業務運営方針
        </a>
      </div>
      <p class="copyright">
        &copy; 有限会社スマイルファミリー all rights reserved.
      </p>
    </div>
  </footer>
</template>

<style scoped>
footer {
  border-top: 5px solid #8b4812;
  padding: 32px;
  background: linear-gradient(to right, #ffdcb6, #ffe2b6);
  color: #45230b;
  font-size: 16px;
  line-height: 1.6;
}
.container {
  max-width: 1000px;
  margin: 0 auto;
}

.policy_links {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 14px;
}
.policy_links a {
  color: #45230b;
  text-decoration: none;
  border-bottom: 1px solid #45230b;
  transition: opacity 0.3s ease;
}
.policy_links a:hover {
  opacity: 0.6;
}
.separator {
  margin: 0 16px;
  opacity: 0.4;
}
.copyright {
  margin-top: 8px;
}

@media (max-width: 800px) {
  footer {
    padding: 16px;
    font-size: 12px;
  }

  .policy_links {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    font-size: 12px;
    width: fit-content;
  }

  .separator {
    display: none;
  }
}
</style>
